import React, { Fragment, useState } from "react";
import Moment from "react-moment";

const ProfileCommentsReplyItem = ({
  user,
  profile,
  id,
  profile_channelid,
  commentId,
  reply: {
    _id,
    reply_deleted,
    avatar,
    role,
    channelid,
    text,
    gif,
    firstname,
    lastname,
    jobtitle,
    verified_account,
    date,
  },
  DeleteReply,
  setReportedUser,
  setShowReportUser,
  setBannedUser,
  setShowBanUserReply,
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Fragment>
      <div className="reply">
        <div className="reply-connect">
          <div
            className={`connect ${
              role && role === "innovator"
                ? "background-green"
                : role && role === "mentor"
                ? "background-red"
                : role && role === "employer"
                ? "background-blue"
                : ""
            }`}
          ></div>
        </div>
        <div
          className={`reply-post ${
            profile.channelid === channelid ? "red" : "grey"
          } `}
        >
          <div className="comment-user-container">
            <div className="comment-user">
              <div className="comment-avi-container">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  alt="avatar"
                  className="comment-avi"
                />
              </div>
              <ul className="post-user-items">
                <div className="align-center">
                  <li
                    className={`item-font ${
                      role && role === "innovator"
                        ? "green"
                        : role && role === "mentor"
                        ? "red"
                        : role && role === "employer"
                        ? "blue"
                        : ""
                    } bold`}
                  >
                    {channelid}{" "}
                  </li>
                  {profile.channelid === channelid ? (
                    <i class="fa-solid fa-crown translate-y mx-5 gold"></i>
                  ) : (
                    ""
                  )}
                  {verified_account && (
                    <div>
                      <i
                        class={`fa-regular fa-circle-check fa-sm ${
                          role && role === "innovator"
                            ? "green"
                            : role && role === "mentor"
                            ? "red"
                            : role && role === "employer"
                            ? "blue"
                            : ""
                        } mr-5`}
                      ></i>
                    </div>
                  )}
                </div>
                <li className="stream-item bold">
                  {firstname} {channelid === "roland" ? "" : lastname}
                </li>
                <li className="stream-item">{jobtitle}</li>
              </ul>
            </div>
            <div className="comment-date">
              <Moment format="MM/DD/YYYY">{date}</Moment>
            </div>
            <div className="comment-header-container">
              {showModal && (
                <div className="modal">
                  <ul className="modal-items">
                    {user.channelid !== channelid &&
                      user.channelid === profile.channelid && (
                        <li
                          onClick={() => {
                            setShowBanUserReply({
                              submit: true,
                              confirm: false,
                            });
                            setBannedUser({
                              ...setBannedUser,
                              comment_id: commentId,
                              reply_id: _id,
                              role,
                              channelid: channelid,
                              avatar: avatar,
                              firstname: firstname,
                              lastname: lastname,
                              text,
                              image: "",
                              video: "",
                              gif,
                            });
                          }}
                          className="modal-item"
                        >
                          <i className="fas fa-ban mx-5 red"></i>
                          Ban
                        </li>
                      )}
                    {user.channelid !== channelid && (
                      <li
                        className="modal-item"
                        onClick={() => {
                          setShowReportUser({ submit: true, confirm: false });
                          setReportedUser({
                            role,
                            channelid,
                            avatar,
                            firstname,
                            lastname,
                            text,
                            image: "",
                            video: "",
                            gif: "",
                          });
                        }}
                      >
                        <i
                          className={`fas fa-flag mx-5 ${
                            role && role === "innovator"
                              ? "green"
                              : role && role === "mentor"
                              ? "red"
                              : role && role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        ></i>
                        Report
                      </li>
                    )}
                    {user.channelid === channelid && (
                      <li
                        onClick={() =>
                          DeleteReply(id, commentId, _id, profile_channelid)
                        }
                        className="modal-item"
                      >
                        <i
                          className={`fas fa-times mx-5 ${
                            role && role === "innovator"
                              ? "green"
                              : role && role === "mentor"
                              ? "red"
                              : role && role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        ></i>
                        Delete
                      </li>
                    )}
                    {user.channelid !== channelid &&
                      user.channelid === profile.channelid && (
                        <li
                          onClick={() =>
                            DeleteReply(id, commentId, _id, profile_channelid)
                          }
                          className="modal-item"
                        >
                          <i
                            className={`fas fa-times mx-5 ${
                              role && role === "innovator"
                                ? "green"
                                : role && role === "mentor"
                                ? "red"
                                : role && role === "employer"
                                ? "blue"
                                : ""
                            }`}
                          ></i>
                          Delete
                        </li>
                      )}
                  </ul>
                </div>
              )}
              {!reply_deleted && (
                <i
                  onClick={() => {
                    if (showModal) {
                      setShowModal(false);
                    } else {
                      setShowModal(true);
                    }
                  }}
                  className={`fa-solid fa-ellipsis cursor ${
                    role && role === "innovator"
                      ? "green"
                      : role && role === "mentor"
                      ? "red"
                      : role && role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>
              )}
            </div>
          </div>
          {gif !== "" && (
            <img src={gif} alt="media" className="reported-media-alt" />
          )}
          <div className="comment-text-container">
            {text !== "" && <p className="post-text">{text}</p>}
          </div>
          {/* <div className="comment-action-buttons">
            <div className="comment-left-buttons">
              <i
                className={`far fa-thumbs-up mx-5 ${
                  role && role === "innovator"
                    ? "green"
                    : role && role === "mentor"
                    ? "red"
                    : role && role === "employer"
                    ? "blue"
                    : ""
                }`}
              ></i>
              <span className="white"></span>
            </div>
          </div> */}
        </div>
      </div>
    </Fragment>
  );
};

export default ProfileCommentsReplyItem;
